import request from "@/utils/request";
export const login = (params) => {
    return request.post("/verify/logIn", params);
};
